import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { Button, TextField, InputAdornment, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';
import Swal from 'sweetalert2'

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { decodeHTMLEntities } from '../../../../Functions/utils';
import { create } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';

import { toastTimerValue } from '../../../../Shared/utils';
import '../../../SweetAlert.css'


export default function CreateGroup({groups, setGroups, setSelectedGroup}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [newGroup, setNewGroup] = useState({name: '', management: 'France', wipeReport: 'XLS', pageSize: 'A4'});
  const [{ user }, appDispatch] = useAppContext();
  const [{ groupsLocationsStatus }, eventDispatch] = useEventContext();

  const handleCreateGroup = (e, group) => {
    e.preventDefault();
    if (!group.name) {
      return toast(decodeHTMLEntities(t('admin.groups.errors.incomplete', {name: group.name})), {type: 'error'});

      // return Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('admin.groups.errors.incomplete', {name: group.name}),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }

    setLoading(true);

    create({type: 'group', group}).then(res => {
      setLoading(false);
      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.groups.errors.' + res, {name: group.name})), {type: 'error'});
      }

      const newGroups = groups.concat(res.group);
      setGroups(newGroups.sort((a, b) => a.name.localeCompare(b.name)));

      setSelectedGroup(null);
      toast(decodeHTMLEntities(t('admin.groups.create.success', {name: group.name})), {type: 'success'});

      appDispatch({ forceReload: true });
      eventDispatch({ groupsLocationsStatus: 'pending' });
    });
  };


  return (
    <Prompt animated>
      <form className="prompt__container animated" onSubmit={e => handleCreateGroup(e, newGroup)}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('admin.groups.create.title')}</h1>
            <div style={{textAlign: 'unset', width: '50%', margin: '20px auto 0'}}>
              <FormControl variant="outlined" style={{width: '100%'}}>
                <InputLabel>{t('admin.groups.columns.management')}</InputLabel>
                <Select
                  value={newGroup.management}
                  label={t('admin.groups.columns.management')}
                  onChange={e => {
                    const management = e.target.value;
                    const pageSize = management === 'US' ? 'LETTER' : 'A4';
                    setNewGroup({...newGroup, management, pageSize});
                  }}
                >
                  <MenuItem value="France">France</MenuItem>
                  <MenuItem value="US">US</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="prompt__content">
            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">description</span>
                </InputAdornment>
              }}
              required
              variant="outlined"
              value={newGroup.name}
              inputProps={{maxLength: 50}}
              label={t('admin.groups.columns.name')}
              onChange={e => setNewGroup({...newGroup, name: e.target.value})}
            />
          </div>
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setSelectedGroup(null)}>
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary" type="submit" disabled={loading}>
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)"/> : t('global.create')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
